// react-magnetic-di - temporary comment, for auto dependency injection in tests
import { useCallback } from 'react';

import isObject from 'lodash/isObject';

import { fireErrorAnalytics } from '@atlassian/ui-modifications-analytics';

import { useViewType } from '../../../../../../../controllers/issue-adjustments/hooks/use-view-type';
import { useIssueAdjustmentsActions } from '../../../../../../../controllers/issue-adjustments/main';
import { getAnalytics } from '../../../../../../../controllers/view-configuration';

import { BRIDGE_ERROR_TYPES } from './constants';
import type { OnBridgeError, OnBridgeErrorPayload } from './types';

const isValidPayload = (payload: OnBridgeErrorPayload): boolean =>
	payload !== undefined &&
	isObject(payload) &&
	BRIDGE_ERROR_TYPES.includes(payload.error) &&
	(!payload.changeId || typeof payload.changeId === 'string');

export const useOnBridgeError = ({ appId }: { appId: string }): OnBridgeError => {
	const { setError, unregisterFields } = useIssueAdjustmentsActions();
	const viewType = useViewType();

	return useCallback<OnBridgeError>(
		(payload) => {
			if (!isValidPayload(payload)) {
				return;
			}

			const { changeId, error, cause } = payload;
			if (changeId) {
				unregisterFields({ changeId, appId });
			}
			setError({
				errorCode: 'ON_BRIDGE_ERROR_ERROR_CODE',
			});

			getAnalytics(viewType).stopTTI({
				completionStatus: 'error',
				viewType,
			});

			const UIMLoggableError = new Error(
				`An ${error} occurred in the UI Modifications code in the Jira Bridge`,
				{ cause },
			);

			fireErrorAnalytics({
				error: UIMLoggableError,
				id: 'UIModificationsJiraBridge',
				viewType,
				attributes: {
					type: error,
					cause,
				},
			});
		},
		[setError, unregisterFields, viewType, appId],
	);
};
